import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import * as ls from 'local-storage';

import {
  getOnline,
  getUpdateAvailable,
  getServerUp,
  getId,
  getUserName,
  getUserDistrictName,
  getFirstName,
  getLastName,
  getUserDistrictId,
  getBuildDate,
} from 'State/selectors';
import getDatabase, { getDatabaseNames } from 'Common/DB';
import { isSessionExpired } from 'Common/Security/SecurityHelpers';
import { syncOfflineTransactionHistory } from 'Offline/actions';
import {
  STORAGE_IDLE_TIME_UTC,
  SESSION_LENGTH_MINUTES,
} from 'Common/Constants';
import { token } from 'API/MPWApi';

import * as supportToolActions from './state/actions';

class SupportTools extends React.Component {
  componentDidMount() {
    window.SupportTools = this;
    window.supportTools = this;
    window.supporttools = this;
  }

  get help() {
    return this.list;
  }
  get list() {
    return this.outputList('Command List', [
      'info',
      'recalculateRecipeNutrients',
      'syncOfflineTransactions',
      'offlineTransactionsStatus',
      'tokenInfo',
      'tokenRefresh',
      'sessionInfo',
      'resetVerification',
    ]);
  }

  get recalculateRecipeNutrients() {
    const { recalculateAllRecipeNutrients } = this.props;
    const proceed = window.confirm(
      'This command will recalculate the nutrient values for all recipes in the database. \n\n Do you wish to continue?'
    );

    if (proceed) {
      (async () => {
        await recalculateAllRecipeNutrients();
      })();

      return 'Recalculation Enqueued';
    }

    return 'Command Canceled';
  }

  get syncOfflineTransactions() {
    const { online, serverUp, syncOfflineTransactionHistory } = this.props;

    if (!online || !serverUp) {
      return "Transaction Sync cannot run while you're offline or the server is down.";
    }

    (async () => {
      await syncOfflineTransactionHistory(true);
    })();

    return 'async';
  }

  get offlineTransactionsStatus() {
    (async () => {
      try {
        const databaseNames = await getDatabaseNames();
        for (const databaseName of databaseNames) {
          console.group(`--- ${databaseName} --`);

          const DB = await getDatabase(databaseName);
          console.log(
            'Pending Transaction History: ' +
              (await DB.TransactionHistory.count())
          );
          console.log(
            'Transaction History Errors: ' +
              (await DB.TransactionHistoryErrorLogs.count())
          );

          console.groupEnd();
        }
      } catch (e) {}
    })();

    return 'async';
  }

  get info() {
    const {
      userId,
      username,
      name,
      districtName,
      districtId,
      online,
      serverUp,
      updateAvailable,
      buildDate,
    } = this.props;

    return this.outputList('Info', [
      `User Id:          ${userId}`,
      `Username:         ${username}`,
      `Name:             ${name}`,
      `District Name:    ${districtName}`,
      `District Id:      ${districtId}`,
      `Online:           ${online}`,
      `Logged In:        ${token.isValid()}`,
      `Server Up:        ${serverUp}`,
      `Update Available: ${updateAvailable}`,
      `Version built at: ${buildDate}`,
    ]);
  }

  get tokenInfo() {
    return this.outputList('Token Info', [
      `Is token valid: ${token.isValid() ? 'Yes' : 'No'}`,
      `Token expires ${token.expiresIn()}`,
    ]);
  }

  get tokenRefresh() {
    if (!token.isValid()) {
      return 'Refresh failed, the token is missing or expired.';
    }

    console.log('Attempting to refresh the token.');

    (async () => {
      if (!(await token.refresh())) {
        console.log('Refresh request failed.');
        console.log(`Error message: ${token._refreshError}`);
        return;
      }
      console.log('Token refreshed.');
    })();

    return 'async';
  }

  get sessionInfo() {
    const idleTime = moment(ls.get(STORAGE_IDLE_TIME_UTC));
    const expired = isSessionExpired(idleTime, moment().utc()) ? 'Yes' : 'No';

    return this.outputList('Session Info', [
      `Is session expired: ${expired}`,
      `Session idle ${idleTime.isValid() ? idleTime.fromNow() : undefined}`,
      `Logout after idle ${SESSION_LENGTH_MINUTES} minutes`,
    ]);
  }

  get resetVerification() {
    const { resetVerification } = this.props;
    const proceed = window.confirm(
      'This command will reset Verification.\n\nDo you wish to continue?'
    );

    if (proceed) {
      (async () => {
        await resetVerification();
      })();

      return 'Reset Verification Enqueued';
    }

    return 'Command Canceled';
  }

  /**
   * Output a grouped list to the console.
   *
   * @param {string} title
   * @param {array} list
   * @return string
   */
  outputList = (title, list) => {
    console.group(`-------------- ${title} --------------`);

    list.forEach((i) => console.log(i));

    console.groupEnd();
    return 'Done';
  };

  render() {
    return null;
  }
}

const mapStateToProps = (state) => ({
  userId: getId(state),
  username: getUserName(state),
  name: getFirstName(state) + ' ' + getLastName(state),
  districtName: getUserDistrictName(state),
  districtId: getUserDistrictId(state),
  online: getOnline(state),
  serverUp: getServerUp(state),
  updateAvailable: getUpdateAvailable(state),
  buildDate: getBuildDate(state),
});

SupportTools = connect(mapStateToProps, {
  syncOfflineTransactionHistory,
  ...supportToolActions,
})(SupportTools);

export { SupportTools };



// WEBPACK FOOTER //
// ./src/common/SupportTools/SupportTools.js